export const routesConfig = {
  categories: {
    tabbar: '底部导航',
    auth: '认证相关',
    profile: '个人中心',
    customer: '客户管理',
    assign: '推广员功能',
    admin: '管理员功能',
    message: '消息中心',
    // wallet: '钱包相关', // 已注释：CRM项目不需要钱包功能
    about: '关于我们'
  }
}

export const allRoutes = [
  { path: '/', redirect: '/home' },

  {
    path: '/login',
    name: 'login',
    component: () => import('../pages/account/login.vue'),
    meta: { requiresAuth: false, title: '登录', category: 'auth' }
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('../pages/account/register.vue'),
    meta: { requiresAuth: false, title: '注册', category: 'auth' }
  },
  {
    path: '/forget-password',
    name: 'forgetPassword',
    component: () => import('../pages/account/forget-password.vue'),
    meta: { requiresAuth: false, title: '忘记密码', category: 'auth' }
  },

  {
    path: '/home',
    name: 'home',
    component: () => import('../pages/home/index.vue'),
    meta: { requiresAuth: false, title: '首页', icon: 'home-o', category: 'tabbar', showInTabbar: true }
  },

  {
    path: '/customer',
    name: 'customerList',
    component: () => import('../pages/customer/index.vue'),
    meta: { requiresAuth: false, title: '客户列表', icon: 'friends-o', category: 'tabbar', showInTabbar: true }
  },
  {
    path: '/customer/add',
    name: 'customerAdd',
    component: () => import('../pages/customer/add.vue'),
    meta: { requiresAuth: true, title: '录入客户', category: 'customer' }
  },
  {
    path: '/customer/:id',
    name: 'customerDetail',
    component: () => import('../pages/customer/detail.vue'),
    meta: { requiresAuth: true, title: '客户详情', category: 'customer' },
    props: route => ({ userId: route.params.id })
  },
  {
    path: '/recycle',
    name: 'recycle',
    component: () => import('../pages/recycle/index.vue'),
    meta: { requiresAuth: true, title: '回收站', category: 'customer', roles: ['system', 'brand', 'store', 'assign', 'follow'] }
  },

  {
    path: '/assign',
    name: 'assignFollowing',
    component: () => import('../pages/assign/following.vue'),
    meta: { requiresAuth: true, title: '跟进情况', icon: 'todo-list-o', category: 'tabbar', showInTabbar: true, roles: ['system', 'brand', 'store', 'assign'] }
  },
  {
    path: '/assign/add',
    name: 'assignAdd',
    component: () => import('../pages/customer/add.vue'),
    meta: { requiresAuth: true, title: '录入客户', category: 'assign', roles: ['assign'] }
  },
  {
    path: '/assign/unassigned',
    name: 'assignUnassigned',
    component: () => import('../pages/assign/index.vue'),
    meta: { requiresAuth: true, title: '待分配', category: 'assign', roles: ['assign'] }
  },

  {
    path: '/admin/audit',
    name: 'adminAudit',
    component: () => import('../pages/admin/audit.vue'),
    meta: { requiresAuth: true, title: '订单审核', icon: 'orders-o', category: 'tabbar', showInTabbar: true, roles: ['system', 'brand', 'store'] }
  },
  {
    path: '/admin/stats',
    name: 'adminStats',
    component: () => import('../pages/admin/stats.vue'),
    meta: { requiresAuth: true, title: '数据统计', icon: 'chart-trending-o', category: 'tabbar', showInTabbar: true, roles: ['system', 'brand', 'store', 'assign'] }
  },
  {
    path: '/admin/customer',
    name: 'adminCustomer',
    component: () => import('../pages/admin/customer.vue'),
    meta: { requiresAuth: true, title: '客户管理', category: 'admin', roles: ['system', 'brand', 'store'] }
  },

  {
    path: '/message',
    name: 'messageList',
    component: () => import('../pages/message/index.vue'),
    meta: { requiresAuth: false, title: '消息中心', icon: 'bell', category: 'tabbar', showInTabbar: true }
  },

  {
    path: '/activity',
    name: 'activityList',
    component: () => import('../pages/activity/index.vue'),
    meta: { requiresAuth: true, title: '跟进动态', category: 'home' }
  },

  {
    path: '/profile',
    name: 'profile',
    component: () => import('../pages/profile/index.vue'),
    meta: { requiresAuth: false, title: '我的', icon: 'user-o', category: 'tabbar', showInTabbar: true }
  },

  {
    path: '/profile/edit',
    name: 'profileEdit',
    component: () => import('../pages/profile/edit.vue'),
    meta: { requiresAuth: true, title: '编辑个人资料' }
  },

  {
    path: '/profile/settings',
    name: 'settings',
    component: () => import('../pages/settings/index.vue'),
    meta: { requiresAuth: true, title: '设置' }
  },
  {
    path: '/profile/settings/change-password',
    name: 'changePassword',
    component: () => import('../pages/settings/change-password.vue'),
    meta: { requiresAuth: true, title: '修改密码' }
  },
  {
    path: '/profile/settings/bind-phone',
    name: 'bindPhone',
    component: () => import('../pages/settings/bind-phone.vue'),
    meta: { requiresAuth: true, title: '绑定手机' }
  },

  // ========== 钱包相关功能已注释（CRM项目不需要）==========
  // {
  //   path: '/balance',
  //   name: 'balance',
  //   component: () => import('../pages/wallet/balance.vue'),
  //   meta: { requiresAuth: true, title: '我的余额', category: 'wallet' }
  // },
  // {
  //   path: '/sign',
  //   name: 'sign',
  //   component: () => import('../pages/wallet/sign.vue'),
  //   meta: { requiresAuth: true, title: '签到打卡', category: 'wallet' }
  // },
  // {
  //   path: '/invite',
  //   name: 'invite',
  //   component: () => import('../pages/wallet/invite.vue'),
  //   meta: { requiresAuth: true, title: '邀请好友', category: 'wallet' }
  // },
  // {
  //   path: '/recharge',
  //   name: 'recharge',
  //   component: () => import('../pages/wallet/recharge.vue'),
  //   meta: { requiresAuth: true, title: '充值', category: 'wallet' }
  // },
  // {
  //   path: '/withdraw',
  //   name: 'withdraw',
  //   component: () => import('../pages/wallet/withdraw.vue'),
  //   meta: { requiresAuth: true, title: '提现', category: 'wallet' }
  // },

  {
    path: '/notice',
    name: 'notice',
    component: () => import('../pages/notice/index.vue'),
    meta: { requiresAuth: true, title: '通知公告', icon: 'notice-o' }
  },
  {
    path: '/notice/detail/:id(\\d+)',
    name: 'noticeDetail',
    component: () => import('../pages/notice/detail.vue'),
    meta: { requiresAuth: true, title: '公告详情' },
    props: route => ({ id: route.params.id })
  },

  {
    path: '/about',
    name: 'about',
    component: () => import('../pages/about/index.vue'),
    meta: { requiresAuth: false, title: '关于我们', category: 'about' }
  },
  {
    path: '/about/privacy',
    name: 'privacy',
    component: () => import('../pages/about/privacy.vue'),
    meta: { requiresAuth: false, title: '隐私政策' }
  },
  {
    path: '/about/agreement',
    name: 'agreement',
    component: () => import('../pages/about/agreement.vue'),
    meta: { requiresAuth: false, title: '用户协议' }
  },
  {
    path: '/about/help',
    name: 'aboutHelp',
    component: () => import('../pages/about/help.vue'),
    meta: { requiresAuth: false, title: '帮助中心' }
  },

  {
    path: '/403',
    name: 'forbidden',
    component: () => import('../pages/error/403.vue'),
    meta: { requiresAuth: false, title: '访问被拒绝' }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'notFound',
    component: () => import('../pages/error/404.vue'),
    meta: { requiresAuth: false, title: '页面不存在' }
  }
]
